<template>
  <div style="height: 100%;">
    <v-card style="width: 100%; height: 100%;">
      <v-card-title style="height: 3rem; margin: 0; display: block; padding: 0 8px;">
        <ul
            style="
              background-color: rgb(51,82,128);
              border-radius: 8px;
              color: white;
              display: inline-flex;
              margin: 4px 0px 0px 8px;
              padding: 6px;
              list-style: none;
            "
        >
          <li style="display: inline-flex;">
            <RoundCheckbox :source="''" :isDisplay="true" :checked="false" :disabled="true" :update="null"/>
            <span style="padding-left: 12px">Non-Applicable</span>
          </li>
          <li style="display: inline-flex; margin-left: 8px">
            <RoundCheckbox :source="''" :isDisplay="true" :checked="false" :disabled="false" :update="null"/>
            <span style="padding-left: 12px">Non-Validated</span>
          </li>
          <li style="display: inline-flex; margin-left: 8px">
            <RoundCheckbox :source="''" :isDisplay="true" :checked="true" :disabled="false" :update="null"/>
            <span style="padding-left: 12px">Validated</span>
          </li>
        </ul>
        <LogButton
            style="color:white; background-color: rgb(51,82,128); border-radius: 8px; float: right;"
            :file="'fault-rules'"
            :notification_table="'fault_rules'"
        />
      </v-card-title>
      <v-card-media style="height: calc(100% - 8rem); padding: 0 16px;">
        <dx-data-grid
            class="grid"
            :data-source="rulesGrid"
            :show-column-lines="true"
            :show-row-lines="true"
            :show-borders="true"
            :word-wrap-enabled="true"
            :row-alternation-enabled="false"
            :column-auto-width="true"
        >
          <DxHeaderFilter :visible="true"/>
          <DxPaging :page-size="17"/>
          <dx-column data-field="rule" caption="Rules"/>
          <dx-column data-field="fault" caption="Fault"/>
          <dx-column
              data-field="wecs"
              caption="WECS"
              cell-template="validationTemplate"
          >
            <DxHeaderFilter :data-source="systemsFilterSource"/>
          </dx-column>
          <dx-column
              data-field="unic"
              caption="UNIC"
              cell-template="validationTemplate"
          >
            <DxHeaderFilter :data-source="systemsFilterSource"/>
          </dx-column>
          <dx-column
              data-field="unic_df"
              caption="UNIC DF"
              cell-template="validationTemplate"
          >
            <DxHeaderFilter :data-source="systemsFilterSource"/>
          </dx-column>
          <dx-column
              data-field="wice"
              caption="WICE"
              cell-template="validationTemplate"
          >
            <DxHeaderFilter :data-source="systemsFilterSource"/>
          </dx-column>
          <dx-column
              data-field="wice_df"
              caption="WICE DF"
              cell-template="validationTemplate"
          >
            <DxHeaderFilter :data-source="systemsFilterSource"/>
          </dx-column>
          <div slot="validationTemplate" slot-scope="{data}">
            <RoundCheckbox
                :source="data.row.data.rule + ',' + data.column.dataField"
                :checked="data.value > 0"
                :disabled="data.value < 0"
                :update="onChange"
                :isDisplay="!updateAllowed"
            />
          </div>
        </dx-data-grid>
      </v-card-media>
      <v-card-actions style="height: 1rem;">
        <v-btn
            v-if="updateAllowed"
            :disabled="!pendingUpdates"
            style="color:white;
            background-color: rgb(51,82,128);"
            @click="openChangesPanel"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="showChangesDialog" width="840" height="600">
      <v-card style="width:840px;height:600px;">
        <v-card-title primary class="title" style="height:10%;">Validate Rules</v-card-title>
        <v-card-media style="height:80%; max-height:80%; overflow-y:auto; padding: 0 16px; width: calc(100% - 0)">
          <v-layout column>
            <v-flex d-flex md8>
              <dx-data-grid
                  class="grid"
                  :data-source="updatesGrid"
                  :show-column-lines="true"
                  :show-row-lines="true"
                  :show-borders="true"
                  :word-wrap-enabled="true"
                  :row-alternation-enabled="false"
                  :column-auto-width="true"
                  style="width: calc(100% - 16px)"
              >
                <DxPaging :page-size="6"/>
                <dx-column data-field="rule" caption="Rules"/>
                <dx-column data-field="wecs" caption="WECS" cell-template="validationTemplate"/>
                <dx-column data-field="unic" caption="UNIC" cell-template="validationTemplate"/>
                <dx-column data-field="unic_df" caption="UNIC DF" cell-template="validationTemplate"/>
                <dx-column data-field="wice" caption="WICE" cell-template="validationTemplate"/>
                <dx-column data-field="wice_df" caption="WICE DF" cell-template="validationTemplate"/>
                <div slot="validationTemplate" slot-scope="{data}">
                  <RoundCheckbox
                      :source="data.row.data.rule + ',' + data.column.dataField"
                      :checked="data.value > 0"
                      :disabled="data.value < 0"
                      :isDisplay="true"
                  />
                </div>
              </dx-data-grid>
            </v-flex>
            <v-flex d-flex md4 style="padding-top: 16px;">
              <v-layout column>
                <v-flex d-flex md6>
                  <v-text-field
                      v-model="username"
                      label="Username"
                  />
                </v-flex>
                <v-flex d-flex md6>
                  <v-textarea
                      v-model="comment"
                      label="Comment"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-media>
        <v-card-actions style="height:10%;">
          <v-spacer/>
          <v-btn color="primary" flat @click="cancelDialog">Cancel</v-btn>
          <v-btn style="color:white; background-color: rgb(51,82,128);" @click="saveChanges">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import {DxColumn, DxDataGrid, DxHeaderFilter, DxPaging, DxScrolling} from "devextreme-vue/data-grid";
import LogButton from "@/components/LogButton";
import RoundCheckbox from "@/components/RoundCheckbox";
import {getData} from "../getData.js";
import axios from "axios";
import {store} from "@/main";

var apiService;

export default {
  name: "Rules",
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxHeaderFilter,
    DxScrolling,
    RoundCheckbox,
    LogButton
  },
  data() {
    return {
      rules: {},
      updates: {},
      rulesGrid: [],
      updatesGrid: [],
      validation_groups: [
        {
          "field": "wecs",
          "caption": "WECS"
        },
        {
          "field": "unic",
          "caption": "UNIC"
        },
        {
          "field": "unic_df",
          "caption": "UNIC DF"
        },
        {
          "field": "wice",
          "caption": "WICE"
        },
        {
          "field": "wice_df",
          "caption": "WICE DF"
        },
      ],
      systemsFilterSource: [
        {
          'text': 'Non-Applicable',
          'value': -1
        },
        {
          'text': 'Non-Validated',
          'value': 0
        },
        {
          'text': 'Validated',
          'value': 1
        }
      ],
      pendingUpdates: false,
      showChangesDialog: false,
      username: "",
      comment: "",
    }
  },
  created() {
    apiService = new getData();
  },
  mounted() {
    apiService.getRules()
  },
  methods: {
    rulesDisplay: function () {
      store.loading = true;
      this.rulesGrid = [];

      let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});

      Object.keys(this.rules).sort(collator.compare).filter((rule) => {
        return this.rules[rule].rule.toLowerCase().indexOf('wecs') < 0 && this.rules[rule].rule.toLowerCase().indexOf('wice') < 0
      }).map((rule) => {
        this.rulesGrid.push({
          "rule": rule,
          "fault": this.rules[rule].faults,
          "wecs": this.rules[rule].validated.wecs,
          "unic": this.rules[rule].validated.unic,
          "unic_df": this.rules[rule].validated.unic_df,
          "wice": this.rules[rule].validated.wice,
          "wice_df": this.rules[rule].validated.wice_df,
        })
      })

      store.loading = false;
    },
    changesDisplay: function () {
      this.updatesGrid = [];

      Object.keys(this.updates).sort().map((rule) => {
        this.updatesGrid.push({
          "rule": rule,
          "wecs": (typeof this.updates[rule].validated.wecs != 'undefined' ? this.updates[rule].validated.wecs : this.rules[rule].validated.wecs),
          "unic": (typeof this.updates[rule].validated.unic != 'undefined' ? this.updates[rule].validated.unic : this.rules[rule].validated.unic),
          "unic_df": (typeof this.updates[rule].validated.unic_df != 'undefined' ? this.updates[rule].validated.unic_df : this.rules[rule].validated.unic_df),
          "wice": (typeof this.updates[rule].validated.wice != 'undefined' ? this.updates[rule].validated.wice : this.rules[rule].validated.wice),
          "wice_df": (typeof this.updates[rule].validated.wice_df != 'undefined' ? this.updates[rule].validated.wice_df : this.rules[rule].validated.wice_df),
        })
      })
    },
    onChange: function (source, checked) {
      let [rule, key] = source.split(',');

      this.rules[rule].validated[key] = (checked ? 1 : 0);

      if (store.rules[rule].validated[key] != this.rules[rule].validated[key]) {
        if (Object.keys(this.updates).indexOf(rule) < 0) {
          this.updates[rule] = {"validated": {}};
          this.updates[rule].validated[key] = this.rules[rule].validated[key];
        } else {
          this.updates[rule].validated[key] = this.rules[rule].validated[key];
        }
      } else if (Object.keys(this.updates).indexOf(rule) > -1) {
        delete this.updates[rule].validated[key];

        if (Object.keys(this.updates[rule].validated).length < 1) {
          delete this.updates[rule];
        }
      }

      this.pendingUpdates = Object.keys(this.updates).length > 0;

      this.rulesDisplay();
    },
    openChangesPanel: function () {
      this.username = store.getUsername();
      this.changesDisplay();

      this.showChangesDialog = Object.keys(this.updates).length > 0
    },
    cancelDialog: function () {
      this.showChangesDialog = false
      this.username = '';
      this.comment = '';
    },
    saveChanges: function () {
      let data = {
        rules: this.updates,
        username: this.username,
        comment: this.comment
      }

      store.loading = true;

      axios
          .post(store.config.api_location + '/faultrules/update', data, {headers: {Authorization: store.userProfile.jwt}})
          .then((res) => {
            if (res.data.success) {
              this.cancelDialog();

              this.updates = {};
              this.pendingUpdates = false;
              this.changesDisplay()

              store.rules = res.data.data.rules;
            } else {
              if (res.data.error.indexOf('no user') > -1) {
                localStorage.setItem('wingd_users_logout_msg', 'Your login expired');
                store.userProfile = {};
                store.userLogged = false;
                window.$cookies.remove('user')
                location.reload(true)
              }
            }
          })
          .catch((e) => {
          })
          .finally(() => {
            store.loading = true;
          });
    }
  },
  computed: {
    incomingRules: () => {
      return store.rules;
    },
    updateAllowed: () => {
      let admin = store.userProfile.roles.filter((item) => {
        return item.toLowerCase().indexOf('admin') > -1
      }).length > 0;

      return admin
    }
  },
  watch: {
    incomingRules: function () {
      this.rules = JSON.parse(JSON.stringify(store.rules));
      this.rulesDisplay()
    }
  }
}
</script>

<style scoped>

</style>